import { defineComponent, createBlock, openBlock, unref, mergeProps } from "vue";
import { Toaster as Toaster_default } from "../../../node_modules/.pnpm/vue-sonner@2.0.0/node_modules/vue-sonner/lib/index.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Sonner",
  props: {
    invert: { type: Boolean },
    theme: {},
    position: {},
    hotkey: {},
    richColors: { type: Boolean },
    expand: { type: Boolean },
    duration: {},
    gap: {},
    visibleToasts: {},
    closeButton: { type: Boolean },
    toastOptions: {},
    class: {},
    style: {},
    offset: {},
    mobileOffset: {},
    dir: {},
    swipeDirections: {},
    icons: {},
    containerAriaLabel: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => (openBlock(), createBlock(unref(Toaster_default), mergeProps({ class: "toaster group" }, props, { style: {
      "--normal-bg": "var(--popover)",
      "--normal-text": "var(--popover-foreground)",
      "--normal-border": "var(--border)"
    } }), null, 16));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Sonner.vue.js.map
